import { Directive, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneNumberFormat]',
  standalone: false,
})
export class PhoneNumberFormatDirective implements OnInit {
  constructor(private ngControl: NgControl) {}

  ngOnInit(): void {
    if (this.ngControl.control?.value) {
      this.formatePhoneNumber(this.ngControl.control.value);
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    this.formatePhoneNumber(value);
  }

  private formatePhoneNumber(value: string): void {
    const newValue = value.replace(/\D/g, '');
    let formattedValue = '';
    if (newValue.length < 11) {
      for (let i = 0; i < newValue.length; i++) {
        if (i === 0 && newValue.length > 0) {
          formattedValue += '(';
        }
        formattedValue += newValue[i];
        if (i === 2 && newValue.length > 3) {
          formattedValue += ')';
        }
        if (
          (i === 2 && newValue.length > 3) ||
          (i === 5 && newValue.length > 6)
        ) {
          formattedValue += '-';
        }
      }
    } else {
      formattedValue = newValue;
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.ngControl.control!.setValue(formattedValue, { emitEvent: false });
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    const numericRegex = /^\d+$/;
    const charCode = event.key;
    if (!numericRegex.test(charCode)) {
      event.preventDefault();
    }
  }
}
